import type { CSS } from '../../stitches.config';
import type { SpacingScale } from './sizes';

export type MaxWidthTypes = 'full' | 'screen' | SpacingScale | string;
export type MaxWidthProps = { maxWidth?: MaxWidthTypes };

export const maxWidthCSS = (maxWidth?: MaxWidthTypes): CSS => {
  if (maxWidth === 'full' || maxWidth === '100%') {
    return { maxWidth: '100%' };
  }

  if (maxWidth === 'screen') {
    return { maxWidth: '100vw' };
  }

  if (typeof maxWidth === 'string' && (maxWidth.includes('vw') || maxWidth.includes('dvw'))) {
    return {
      maxWidth: `${maxWidth}`,
    };
  }

  if (maxWidth != null) {
    return {
      maxWidth: `$${maxWidth}`,
    };
  }

  return {};
};
